// We let the user place an order if they have ANY active download plans w. quota
// It is up to Orders to do in depth checks for matching plans
// ToDo: Maybe do this check every 1hr or so not just on app load?
export const userCanDownload = (user, subscriptions) => {
  // Do not check download quota for non-trial users
  // Not all download quota sources are reflected in AdminNG today
  // See: WEBAPPS-2291
  if (!user?.is_trial) {
    return true;
  }

  return subscriptions.some(subscription => {
    const downloadQuotaEnabled =
      subscription.quota_enabled && subscription.quota_sqkm > 0;
    const hasQuotaLeft = subscription.quota_sqkm - subscription.quota_used > 0;

    return downloadQuotaEnabled && hasQuotaLeft;
  });
};
